import { type TypedDocumentNode, gql } from '@apollo/client';

import { idFromObject } from 'gql/idFromObject';
import { useQuery } from 'hooks/graphql/useQuery';
import { joinFiltersWithOr } from 'lib/algolia';

import type {
  FilterWatchlistQuery,
  FilterWatchlistQueryVariables,
} from './__generated__/useWatchlistFilterValue.graphql';

const WATCHLIST_ALGOLIA_QUERY = gql`
  query FilterWatchlistQuery($id: ID!) {
    market {
      id
      watchlist(id: $id) {
        id
        title
        commonPlayers {
          nodes {
            id
            anyPlayer {
              slug
            }
          }
        }
      }
    }
  }
` as TypedDocumentNode<FilterWatchlistQuery, FilterWatchlistQueryVariables>;

type Props = {
  filterValue: string | undefined;
};

export const useWatchlistFilterValue = ({ filterValue }: Props) => {
  const { data } = useQuery(WATCHLIST_ALGOLIA_QUERY, {
    variables: { id: idFromObject(filterValue ?? '') },
    skip: !filterValue,
  });
  const watchlist = data?.market?.watchlist;
  const playersSlugs = watchlist?.commonPlayers?.nodes?.map(
    player => player.anyPlayer?.slug
  );

  return {
    watchlistFilterValue: joinFiltersWithOr(
      (playersSlugs || [])?.map(slug => `player.slug:${slug}`)
    ),
    watchlistFilterTitle: watchlist?.title ?? '',
  };
};
